/**
 * Nombre court : `1250` → « 1.3k », `2_400_000` → « 2.4M » (bulles de `vl-chips`, widgets).
 *
 * ⚠ Fonction PURE, sans dépendance (01/10/2026) : `vl-chips` (dans le bundle initial) l'appelait par
 * `WidgetHelperService.formatNumeric` — et ce service du tableau de bord importe le thème des
 * graphiques, donc chart.js : 202 Ko minifiés + les services du tableau de bord dans `main`, que
 * télécharge la page de connexion. `WidgetHelperService.formatNumeric` y délègue.
 */
export function formatNumeric(n: number, toFixed: number = 1): string {
  if (n === 0) return "0";
  const suffixes = ["", "k", "m", "M", "T", "P", "E", "Z", "Y"];
  const tier = (Math.log10(Math.abs(n)) / 3) | 0;

  if (tier == 0) return Number.isInteger(n) ? `${n}` : n.toFixed(toFixed);

  const suffix = suffixes[tier];
  const scale = Math.pow(10, tier * 3);
  const formatted = (n / scale).toFixed(toFixed);

  return `${formatted}${suffix}`;
}
